import React from 'react'
import LightSelector from './LightSelector'
import clsx from 'clsx'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8

export function StyleSelectorFormsy(props) {
  const { className, variant = 'outlined', ...rest } = props
  return (
    <LightSelector
      {...rest}
      className={clsx(className, 'w-full')}
      variant={variant}
      MenuProps={{
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center',
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'center',
        },
        getContentAnchorEl: null,
        PaperProps: {
          style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
          },
        },
      }}
    />
  )
}
